import React, { useState, useMemo, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme, useMediaQuery, CardHeader, TextField } from "@mui/material";
import { Box, Divider, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import HomeIcon from "@mui/icons-material/Home";
import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import axios from "axios";
import FormHelperText from "@mui/material/FormHelperText";

const CalculadoraPZ = () => {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const nav = useNavigate();

  //Theme
  const theme = useTheme();

  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Routes
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };
  const [ejecutar, setEjecutar] = React.useState(true);
  const [edades, setEdades] = React.useState([]);
  const [resultCard, setResultCard] = React.useState(false);

  // Input States
  const [peso, setPeso] = React.useState("");
  const [talla, setTalla] = React.useState("");

  //Select States
  const [sexo, setSexo] = React.useState("");

  //DatePicker Value
  const [fechaNac, setFechaNac] = React.useState(null);
  const [fechaEval, setFechaEval] = React.useState(null);

  // Estado para manejar los errores de validación
  const [errors, setErrors] = React.useState({});

  // Estado para deshabilitar el botón de calcular
  const [isCalculateDisabled, setIsCalculateDisabled] = React.useState(false);

  // Estado para controlar la visibilidad del formulario
  const [isFormVisible, setIsFormVisible] = React.useState(true);

  // MODIFICADO: handleSexo para limpiar el error al seleccionar
  const handleSexo = (event) => {
    const value = event.target.value;
    setSexo(value);
    if (errors.sexo) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.sexo;
        return newErrors;
      });
    }
  };

  // Lógica para validar y calcular con mensajes de error
  const handleResultCard = () => {
    const newErrors = {};
    const requiredMessage = "Este campo es requerido";
    if (!fechaEval) newErrors.fechaEval = requiredMessage;
    if (!fechaNac) newErrors.fechaNac = requiredMessage;
    if (!sexo) newErrors.sexo = requiredMessage;
    if (!peso) newErrors.peso = requiredMessage;
    if (!talla) newErrors.talla = requiredMessage;

    setErrors(newErrors);

    // Si hay errores, no continuamos
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // Si no hay errores, procedemos con el cálculo
    let result = edades.filter((ed) => ed.sexo == sexo);
    let datos1 = result.find(({ sexo }) => sexo == "M");
    //var z = (peso - pesoMedio) / Desviacion

    setResultCard(true);
    // Deshabilitar el botón al calcular
    setIsCalculateDisabled(true);

    // Ocultar formulario en vista móvil al calcular
    if (isSmallScreen) {
      setIsFormVisible(false);
    }
  };

  // Función para limpiar el formulario y ocultar el card de resultados
  const handleClear = () => {
    setFechaEval(null);
    setFechaNac(null);
    setSexo("");
    setPeso("");
    setTalla("");
    setEdad("");
    setResultCard(false);
    setErrors({}); // Limpia también los errores
    // Habilitar el botón de calcular nuevamente
    setIsCalculateDisabled(false);
    // Asegurarse de que el formulario vuelva a ser visible
    setIsFormVisible(true);
  };

  ///////////////// CALCULO DE EDAD ///////////////////
  const [edadDias, setEdadDias] = useState("");
  useEffect(() => {
    if (fechaNac && fechaEval) {
      const currentDate = new Date(fechaEval);
      const birthDate = new Date(fechaNac);
      if (!isNaN(birthDate.getTime()) && currentDate > birthDate) {
        const diffTime = currentDate - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        let years = Math.floor(totalDays / 365.25);
        setEdadDias(totalDays)
        setEdad(
          `${years} año(s), ${Math.floor(
            (totalDays % 365.25) / 30.4375
          )} mes(es) y ${totalDays} día(s)`
        );
      } else {
        setEdad("");
      }
    } else {
      setEdad(""); // Limpia la edad si las fechas no están
    }
  }, [fechaNac, fechaEval]);
  ///////////////////////////////////////////////

  // ***MODIFICADO: useEffect para manejar la visibilidad del formulario en cambios de vista***
  useEffect(() => {
    // Si la tarjeta de resultados está visible (es decir, se ha calculado)
    if (resultCard) {
      if (isSmallScreen) {
        // Si se cambia a vista móvil, ocultar el formulario
        setIsFormVisible(false);
      } else {
        // Si se cambia a vista de escritorio, mostrar el formulario
        setIsFormVisible(true);
      }
    } else {
      // Si no se ha calculado (o se limpió), el formulario siempre es visible
      setIsFormVisible(true);
    }
  }, [isSmallScreen, resultCard]); // Se ejecuta cada vez que cambia el tamaño de la pantalla o el estado de resultCard

  const [edad, setEdad] = React.useState("");

  //Modal Handlers
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [oms, setOms] = useState([]);
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [puntaje, setPuntaje] = useState('');
  const getPuntajeZ = async () => {
    try {
      const { data1 } = await axios
        .get("/getPuntajeZ")
        .then(function (response) {
          let datos = response.data;
          console.log(datos);
          let datos1 = datos.find(({ sexo }) => sexo == "M");
          console.log(datos1, "parroquias");
          let result = datos.filter((dato) => dato.sexo == "M");
          setEdades(result);
          console.log(result);
          // setParroquiaSalud(datos1.nombre)
          //         setParroquias(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getOms = async () => {
    try {
      const { data2 } = await axios
        .get("/oms/")
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          let datos = response.data;
         
          setOms(datos);
          setEjecutar(false);
          setCargandoDatos(false);

          return;
        })
        .catch(function (error) {
          console.log("error");
          setCargandoDatos(false);
          return;
        });
    } catch (error) {
      return;
    }
  };

  const buscarParametrosLMS = (edadEnDias, tablaReferencia) =>{
    if (!tablaReferencia || tablaReferencia.length === 0) {
      return null;
    }
  
    // Búsqueda Binaria (más eficiente para arrays grandes y ordenados)
    let bajo = 0;
    let alto = tablaReferencia.length - 1;
    let mejorIndice = -1;
  
    while (bajo <= alto) {
      const medio = Math.floor((bajo + alto) / 2);
      const edadTabla = tablaReferencia[medio].edad_dias;
  
      if (edadTabla === edadEnDias) {
        // Coincidencia exacta encontrada
        return tablaReferencia[medio];
      } else if (edadTabla < edadEnDias) {
        // Este es un candidato válido, guardamos su índice y seguimos buscando a la derecha
        mejorIndice = medio;
        bajo = medio + 1;
      } else { // edadTabla > edadEnDias
        // Este valor es demasiado alto, buscamos a la izquierda
        alto = medio - 1;
      }
    }
    
    // Si no se encontró coincidencia exacta, mejorIndice contendrá el índice del valor inmediatamente menor.
    if (mejorIndice !== -1) {
      return tablaReferencia[mejorIndice];
    }
  
    // Manejo de casos borde: si la edad buscada es menor que la primera edad en la tabla
    if (tablaReferencia.length > 0 && edadEnDias < tablaReferencia[0].edad_dias) {
        console.warn(`Edad en días (${edadEnDias}) es menor que la primera edad en la tabla (${tablaReferencia[0].edad_dias}). Usando el primer valor disponible como fallback.`);
        return tablaReferencia[0];
    }
  
    return null; // No se encontró ningún valor aplicable
  }
  const calcularPuntajeZTallaEdad = (sexo, edadEnDias, tallaCm, datosReferencia) =>{
    // Validaciones de entrada
    if (!sexo || typeof edadEnDias !== 'number' || typeof tallaCm !== 'number' || edadEnDias < 0 || tallaCm <= 0) {
      console.error("Entradas inválidas para calcular puntaje Z:", { sexo, edadEnDias, tallaCm });
      return null;
    }
  
    let tablaReferencia;
    const sexoLower = sexo.toLowerCase();
    if (sexoLower === "femenino" || sexoLower === "f" || sexoLower === "mujer") {
      tablaReferencia = datosReferencia.ninas;
    } else if (sexoLower === "masculino" || sexoLower === "m" || sexoLower === "hombre") {
      tablaReferencia = datosReferencia.ninos;
    } else {
      console.error("Sexo no reconocido:", sexo);
      return null;
    }
  
    if (!tablaReferencia || tablaReferencia.length === 0) {
        console.error(`Datos de referencia para el sexo '${sexo}' no están cargados.`);
        return null;
    }
  
    const parametrosLMS = buscarParametrosLMS(Math.floor(edadEnDias), tablaReferencia);
  
    if (!parametrosLMS) {
      console.error(`No se pudieron obtener parámetros LMS para edad ${Math.floor(edadEnDias)} días y sexo ${sexo}.`);
      return null;
    }
  
    // Acceder a los parámetros L, M, S del objeto encontrado
    const L = parametrosLMS.param_L;
    const M = parametrosLMS.param_M;
    const S = parametrosLMS.param_S;
  
    // Validaciones de los parámetros LMS
    if (L == null || M == null || S == null || M === 0 || (L === 0 && S === 0) || (L !== 0 && (L * S) === 0)) {
      console.error("Parámetros LMS (L, M, o S) son inválidos o nulos:", { L, M, S });
      return null;
    }
    
    let zScore;
    if (L !== 0) {
      zScore = (Math.pow(tallaCm / M, L) - 1) / (L * S);
    } else {
      zScore = Math.log(tallaCm / M) / S; // Math.log es el logaritmo natural (LN)
    }
  
    const zScoreRedondeado = Math.round(zScore * 100) / 100;
  
    if (isNaN(zScoreRedondeado) || !isFinite(zScoreRedondeado)) {
      console.warn("Puntaje Z calculado no es un número finito:", { L, M, S, tallaCm, zScore });
      return null;
    }

    return zScoreRedondeado;
  }
  const puntajeZResultado = useMemo(() => {
    
    
    // Solo calcular si tenemos los datos cargados y los inputs tienen valores válidos
    if (cargandoDatos || !sexo|| !edadDias || !talla) {
      console.log("datos nulos")
        return 'null'; // O null o un texto como '---'
    }
    
    const edadNum = parseInt(edadDias , 10);
    const tallaNum = parseFloat(talla);
    console.log(edadNum)
    console.log(tallaNum)
    if (isNaN(edadNum) || isNaN(tallaNum)) {
      
        return ''; // Valores no numéricos
    }
console.log(oms)
    const zScore = calcularPuntajeZTallaEdad(sexo, edadNum, tallaNum, oms);
   
    setPuntaje(zScore)
    return zScore !== null ? zScore : 'Error'; // Devolver el resultado o un mensaje de error

}, [sexo, edadDias, talla, oms, cargandoDatos]);

  if (ejecutar) {
    getPuntajeZ();
    getOms();
  }

  return (
    <Box m="1.5rem 2.5rem">
      <Box role="presentation" onClick={handleClickBreadCrumbs} sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            href="/inicio"
            onClick={(event) => handleLinkHome(event, "home")}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Inicio
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center" }}
            color="text.primary"
          >
            <ContentPasteOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Calculador de Puntaje Z
          </Typography>
        </Breadcrumbs>
        <Box sx={{ minWidth: 120, mt: isSmallScreen ? 3 : 10 }}>
          <Container>
            {/* Se añade la propiedad 'hidden' para controlar visibilidad */}
            <Card
              sx={{
                borderRadius: 8,
                boxShadow: 5,
                bgcolor: theme.palette.background.alt,
              }}
              hidden={!isFormVisible}
            >
              <CardContent>
                <Typography
                  mt={3}
                  className="text-center"
                  variant={isSmallScreen ? "h4" : "h3"}
                >
                  <b>Calculador de Puntaje Z</b>
                </Typography>
                <Typography
                  mt={1}
                  className="text-center"
                  variant={isSmallScreen ? "h5" : "h4"}
                >
                  (Talla para la edad)
                </Typography>
                <Divider sx={{ mt: 3, mb: 5 }} />
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={12} sm={4}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es"
                    >
                      <DesktopDatePicker
                        label="Fecha de Evaluación"
                        name="fechaEvaluacion"
                        inputFormat="DD/MM/YYYY"
                        value={fechaEval}
                        onChange={(newValue) => {
                          setFechaEval(newValue);
                          // MODIFICADO: Limpiar el error al cambiar el valor
                          if (errors.fechaEval) {
                            setErrors((prev) => ({
                              ...prev,
                              fechaEval: undefined,
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            fullWidth
                            {...params}
                            error={!!errors.fechaEval}
                            helperText={errors.fechaEval}
                          />
                        )}
                        clearable
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es"
                    >
                      <DesktopDatePicker
                        label="Fecha de Nacimiento"
                        name="fechaNacimiento"
                        inputFormat="DD/MM/YYYY"
                        value={fechaNac}
                        onChange={(newValue) => {
                          setFechaNac(newValue);
                          // MODIFICADO: Limpiar el error al cambiar el valor
                          if (errors.fechaNac) {
                            setErrors((prev) => ({
                              ...prev,
                              fechaNac: undefined,
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            fullWidth
                            {...params}
                            error={!!errors.fechaNac}
                            helperText={errors.fechaNac}
                          />
                        )}
                        clearable
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth error={!!errors.sexo}>
                      <InputLabel>Sexo</InputLabel>
                      <Select
                        value={sexo}
                        label="Sexo"
                        onChange={handleSexo}
                        fullWidth
                      >
                        <MenuItem value={"F"}>Femenino</MenuItem>
                        <MenuItem value={"M"}>Masculino</MenuItem>
                      </Select>
                      {errors.sexo && (
                        <FormHelperText>{errors.sexo}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item mt={isSmallScreen ? 0 : 1} xs={12} sm={4}>
                    <TextField
                      label="Peso (Kg)"
                      size="normal"
                      value={peso}
                      onChange={(event) => {
                        const value = event.target.value.replace(/[^\d.]/g, "");
                        setPeso(value);
                        // MODIFICADO: Limpiar el error al cambiar el valor
                        if (errors.peso) {
                          setErrors((prev) => ({ ...prev, peso: undefined }));
                        }
                      }}
                      fullWidth
                      error={!!errors.peso}
                      helperText={errors.peso}
                    />
                  </Grid>
                  <Grid item mt={isSmallScreen ? 0 : 1} xs={12} sm={4}>
                    <TextField
                      label="Talla (cm)"
                      size="normal"
                      value={talla}
                      onChange={(event) => {
                        const value = event.target.value.replace(/[^\d.]/g, "");
                        setTalla(value);
                        // MODIFICADO: Limpiar el error al cambiar el valor
                        if (errors.talla) {
                          setErrors((prev) => ({ ...prev, talla: undefined }));
                        }
                      }}
                      inputProps={{
                        autocomplete: 'off',
                      }}
                      fullWidth
                      error={!!errors.talla}
                      helperText={errors.talla}
                    />
                  </Grid>
                  <Grid item mt={isSmallScreen ? 0 : 1} xs={12} sm={4}>
                    <TextField
                      label="Edad"
                      fullWidth
                      required
                      disabled
                      value={edad}
                      onChange={(event) => setEdad(event.target.value)}
                    />
                  </Grid>
                </Grid>
                <Divider sx={{ mt: 5, mb: 3 }} />
                <Grid container spacing={2} mb={1} justifyContent="center">
                  <Grid item xs={6} sm={3}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{ bgcolor: "teal", color: "white" }}
                      onClick={handleResultCard}
                      fullWidth
                      disabled={isCalculateDisabled}
                    >
                      Calcular
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Box mt={3} hidden={resultCard === false}>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                <CardContent>
                  <Typography
                    mt={1}
                    className="text-center"
                    variant={isSmallScreen ? "h3" : "h3"}
                  >
                    <b>Resultados</b>
                  </Typography>
                  <Divider sx={{ mt: 2, mb: 1 }} />
                  <Grid container spacing={5} justifyContent="center">
                    <Grid item xs={12} sm={3}>
                      <Typography
                        mt={isSmallScreen ? 2 : 3}
                        className="text-center"
                        variant={isSmallScreen ? "h4" : "h3"}
                      >
                        <b>Puntaje Z </b>
                      </Typography>
                      <Typography
                        mt={isSmallScreen ? 1 : 2}
                        className="text-center"
                        variant={isSmallScreen ? "h4" : "h3"}
                      >
                       {puntaje}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Typography
                        mt={isSmallScreen ? 2 : 3}
                        className="text-center"
                        variant={isSmallScreen ? "h4" : "h3"}
                      >
                        <b>Clasificación</b>
                      </Typography>
                      <Typography
                        mt={isSmallScreen ? 1 : 2}
                        mb={isSmallScreen ? 2 : 3}
                        className="text-center"
                        variant={isSmallScreen ? "h4" : "h3"}
                        sx={{ color:puntaje < -3 ? "white" : puntaje < -2 ? "black" : puntaje <= 2 ? "white" : "white",
                          bgcolor:puntaje < -3 ? "firebrick" : puntaje < -2 ? "darkorange" : puntaje <= 2 ? "teal" : "firebrick",
                          borderRadius:2,
                          border:"1px solid black"
                         }}
                      >
                       {puntaje < -3 ? "Talla muy baja" : puntaje < -2 ? "Talla baja" : puntaje <= 2 ? "Adecuada" : "Talla muy alta"}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ mt: 1, mb: 2 }} />
                  <Grid container spacing={2} mb={1} justifyContent="center">
                    <Grid item xs={6} sm={3}>
                      <Button
                        variant="contained"
                        size="large"
                        color="secondary"
                        fullWidth
                        onClick={handleClear}
                      >
                        Limpiar
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default CalculadoraPZ;
